import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { configuration } from "../../appConfig";

// axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

class PageNo extends Component {
  state = {
    words: {},
    lang: "Gb",
    scannerNo: "" 
  }
  componentDidMount = () => {
    this.getLang();
    this.getScannerNo()
  }
  getLang = () => {
    const base_url = window.location.origin;
    axios.get(`${base_url}/lang.json`).then((res) => {
      let lang = localStorage.getItem("lang");
      this.setState({ lang: lang });
      this.setState({ words: res.data });
    });
  };

  lang = (word) => {
    const { lang, words } = this.state;
    let currentLang
    if(this.props.reportType === 'newReportFull' && lang === 'fr'){
      currentLang = 'ch-fr'
    } else{
      currentLang = lang
    }
    return words[word] ? words[word][currentLang] : word;
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }

  getScannerNo = () => {
    const selectedFile = localStorage.getItem("selectedFile");
    const partnerId = localStorage.getItem("partnerId");
    axios.get(
      `${configuration.getData}?vin=${selectedFile}&partnerId=${partnerId}`
    ).then((r) => {
      if (r.data) {
        this.setState({ data: r.data, scannerNo : r.data.ScannerNo});
      }
    });
  }
  
  render() {
    //const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");
    const date = new Date();
    const { scannerNo } = this.state
    return (
      <div
        className="row m-0 hide-report p-0 text-center mb-1 mt-1"
        style={{
          marginBottom: this.props.current === 9 ? 11 : 65,
          display: "flow-root",
          width: "100%",
        }}
      >
        <div className="col">
          <span style={{ float: "center", color:"black" }}>
            Copyright<sup style={{fontSize:"12px"}}>&#169;</sup> <b>ADI</b><sup style={{fontSize:"15px", top: "-4.2px"}}>&#174;</sup> {date.getFullYear()} {this.lang("All rights reserved.")} &nbsp; Scanner:{" "} {scannerNo} &nbsp; {localStorage.getItem("client") === 'SWISS'? this.lang('Order NO') : 'Vin' }: {selectedFile}
          </span>
        </div>
        {/* <span style={{ float: "right",fontWeight:'bold',fontSize:32,color:'black' }}>
          {" Semnature client:_________________"}

        </span> */}
      </div>
    );
  }
}

const mapStateToProps = (props) => {
  return {
    lang: props.lang,
  };
};
export default connect(mapStateToProps)(PageNo);